import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      //name: 'home',
      meta: {
        requiresAuth: true
      },
      component: () => import('@@/Dashboard'),
      children: [
        {
          path: '/',
          name: 'home',
          description: 'Inicio',
          meta: {
            label: 'Inicio'
          },
          component: () => import('@/views/Home')
        },
        {
          path: '/change-password',
          name: 'change-password',
          description: 'Cambiar contraseña',
          meta: {
            label: 'Cambiar contraseña'
          },
          component: () => import('@/views/Usuarios/ChangePassword')
        },
        {
          path: '/informacion-ampliada/:documento([\\d-]+)?',
          name: 'informacion-ampliada',
          description: 'Información ampliada',
          meta: {
            label: 'Información ampliada'
          },
          component: () => import('@/views/InformacionAmpliadaComponent')
        },
        {
          path: '/informacion-contacto',
          name: 'gestion',
          description: 'Gestión',
          meta: {
            label: 'Gestión',
            recordTime: true
          },
          redirect: 'informacion-contacto',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: ':documento([\\d-]+)?',
              name: 'informacion-contacto',
              description: 'Ver Información de Contacto',
              meta: {
                label: 'Información de Contacto'
              },
              component: () => import('@/views/InformacionContacto')
            },
            {
              path: '/abonos/:obligacion_id',
              name: 'ver-abonos',
              description: 'Ver Abonos',
              meta: {
                label: 'Ver Abonos'
              },
              component: () => import('@/views/Abonos')
            },
            {
              path: '/obligacion/:obligacion_id',
              name: 'ver-obligacion',
              description: 'Ver Obligación',
              meta: {
                label: 'Ver Obligación'
              },
              component: () => import('@/views/Obligacion')
            },
            {
              path: '/detalle-obligacion/:obligacion_id',
              name: 'ver-detalle-obligacion',
              description: 'Ver detalle obligación',
              meta: {
                label: 'Ver detalle obligación'
              },
              component: () => import('@/views/DetalleObligacion')
            },
            {
              path: '/historico_gestion/:deudor_id(\\d+)',
              name: 'historico-gestion',
              description: 'Histórico de Gestión',
              meta: {
                label: 'Histórico de Gestión'
              },
              component: () => import('@/views/HistoricoGestion')
            },
            {
              path: '/historico_abonos/:deudor_id(\\d+)',
              name: 'historico-gestion',
              description: 'Histórico de Abonos',
              meta: {
                label: 'Histórico de Abonos'
              },
              component: () => import('@/views/HistoricoAbonos')
            },
            {
              path: '/referencias_deudor/:deudor_id(\\d+)',
              name: 'referencias-deudor',
              description: 'Referencias del deudor',
              meta: {
                label: 'Referencias del deudor'
              },
              component: () => import('@/views/Referencia')
            },
            {
              path: '/informes/lista-campana',
              name: 'lista-campana',
              description: 'Listado para campaña',
              meta: {
                label: 'Listado para campaña'
              },
              component: () => import('@/views/Campana')
            },
            {
              path: '/gestion/:deudor_id(\\d+)?',
              name: 'nueva-gestion',
              description: 'Nueva Gestión',
              meta: {
                label: 'Nueva Gestión'
              },
              component: () => import('@/views/Gestion')
            },
            {
              path: '/acuerdos_pago/:identificacion(\\d+)?',
              name: 'acuerdos-pago',
              description: 'Acuerdos de Pago',
              meta: {
                label: 'Acuerdos de Pago'
              },
              component: () => import('@/views/AcuerdoPago')
            }
          ]
        },
        {
          path: 'administrar',
          name: 'administrar',
          meta: {
            label: 'Administrar'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'casas-cobranza',
              name: 'casas-de-cobranza',
              meta: {
                label: 'Casas de Cobranza'
              },
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  description: 'Casas de Cobranza',
                  meta: {
                    label: 'Lista'
                  },
                  component: () => import('@/views/CasasCobranza/CasasCobranza')
                },
                {
                  path: ':id(\\d+)?',
                  name: 'editar-casa-cobranza',
                  description: 'Editar',
                  meta: {
                    label: 'Editar'
                  },
                  component: () =>
                    import('@/views/CasasCobranza/FormularioCasasCobranza')
                },
                {
                  path: 'crear',
                  description: 'Crear',
                  meta: {
                    label: 'Crear'
                  },
                  component: () =>
                    import('@/views/CasasCobranza/FormularioCasasCobranza')
                }
              ]
            },
            {
              path: 'usuarios',
              name: 'usuarios',
              meta: {
                label: 'Usuarios'
              },
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  description: 'Usuarios',
                  meta: {
                    label: 'Lista'
                  },
                  component: () => import('@/views/Usuarios/Usuarios')
                },
                {
                  path: ':id(\\d+)?',
                  name: 'editar-usuario',
                  description: 'Editar',
                  meta: {
                    label: 'Editar'
                  },
                  component: () => import('@/views/Usuarios/FormularioUsuario')
                },
                {
                  path: 'permiso/:id(\\d+)?',
                  name: 'permiso-usuario',
                  description: 'Permisos',
                  meta: {
                    label: 'Permisos'
                  },
                  component: () => import('@/views/Usuarios/PermisoUsuario')
                },
                {
                  path: 'crear',
                  description: 'Crear',
                  meta: {
                    label: 'Crear'
                  },
                  component: () => import('@/views/Usuarios/FormularioUsuario')
                }
              ]
            },
            {
              path: 'registros-invalidos',
              meta: {
                label: 'Registros Inválidos'
              },
              name: 'registros-invalidos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  description: 'Registros Inválidos',
                  meta: {
                    label: ''
                  },
                  component: () =>
                    import('@/views/RegistrosInvalidos/RegistrosInvalidos')
                },
                {
                  path: 'editar',
                  name: 'editar-registros-invalidos',
                  description: 'Editar Registros Inválidos',
                  meta: {
                    label: 'Editar registros inválidos'
                  },
                  component: () =>
                    import(
                      '@/views/RegistrosInvalidos/FormularioRegistrosInvalidos'
                    )
                }
              ]
            },
            {
              path: 'presupuesto',
              name: 'presupuesto',
              description: 'Presupuesto',
              meta: {
                label: 'Generar presupuesto'
              },
              component: () => import('@/views/Presupuesto')
            },
            {
              path: 'informacion-contacto',
              name: 'informacion-contacto',
              description: 'Importar información de contacto ',
              meta: {
                label: 'Importar información de contacto'
              },
              component: () => import('@/views/ImportarInformacionContacto')
            },
            {
              path: 'cambiar-genero',
              name: 'cambiar-genero',
              description: 'Cambiar genero',
              meta: {
                label: 'Cambiar genero'
              },
              component: () => import('@/views/CambiarGenero')
            },
            {
              path: 'cambiar-nombre',
              name: 'cambiar-nombre',
              description: 'Cambiar nombre',
              meta: {
                label: 'Cambiar nombre'
              },
              component: () => import('@/views/CambiarNombre')
            },
            {
              path: 'cargue-gestion',
              name: 'cargue-gestion',
              description: 'Cargar gestiones',
              meta: {
                label: 'Cargar gestiones'
              },
              component: () => import('@/views/CargueGestion')
            },
            {
              path: 'informacion-sociodemografica',
              name: 'informacion-sociodemografica',
              description: 'Importar información sociodemográfica',
              meta: {
                label: 'Importar información sociodemográfica'
              },
              component: () =>
                import('@/views/ImportarInformacionSociodemografica')
            },
            {
              path: 'informacion-venta-cartera',
              name: 'informacion-venta-cartera',
              description: 'Importar información para venta de cartera',
              meta: {
                label: 'Importar información venta cartera'
              },
              component: () => import('@/views/VentaCartera')
            },
            //Alturas mora
            {
              path: 'altura-mora',
              meta: {
                label: 'Alturas Mora'
              },
              name: 'altura-mora',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  description: 'Obtener alturas de mora',
                  meta: {
                    label: ''
                  },
                  component: () => import('@/views/AlturaMora')
                }
              ]
            }
          ]
        },
        {
          path: 'informes',
          name: 'informes',
          meta: {
            label: 'Informes'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'informe-presupuesto-asesor',
              name: 'informe-presupuesto-asesor',
              description: 'Informe de presupuesto por asesor',
              meta: {
                label: 'Informe de presupuesto por asesor'
              },
              component: () => import('@/views/Informes/InformePresupuesto')
            },
            {
              path: 'asignacion-abono',
              name: 'asignacion-abono',
              description: 'Informe de asignación de abonos',
              meta: {
                label: 'Informe de asignación de abonos'
              },
              component: () => import('@/views/Informes/InformeAbono')
            },
            {
              path: 'informe-gestion',
              name: 'informe-gestion',
              description: 'Informe de gestiones',
              meta: {
                label: 'Informe de gestiones'
              },
              component: () => import('@/views/Informes/InformeGestion')
            },
            {
              path: 'informe-venta-cartera',
              name: 'informe-venta-cartera',
              description: 'Informe exportaciones venta de cartera',
              meta: {
                label: 'Informe exportaciones venta de cartera'
              },
              component: () => import('@/views/Informes/VentaCartera')
            },
            {
              path: 'informe-obligacion',
              name: 'informe-obligacion',
              description: 'Obligaciones',
              meta: {
                label: 'Obligaciones'
              },
              component: () => import('@/views/Informes/InformeObligacion')
            },
            {
              path: 'contacto-deudor',
              name: 'informe_contacto_deudor',
              description: 'Contacto deudor',
              meta: {
                label: 'Contacto deudor'
              },
              component: () => import('@/views/Informes/ContactoDeudor')
            }
          ]
        },
        {
          path: 'appdeudores',
          name: 'App deudores',
          meta: {
            label: 'App deudores'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'usuarios',
              name: 'Usuarios',
              description: 'usuarios de la aplicacion app deudores',
              meta: {
                label: 'Usuarios'
              },
              component: () => import('@/views/Appdeudores/Usuarios')
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Iniciar Sesión',
      component: () => import('./views/Login')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.recordTime)) {
    if (!localStorage.inicioGestion /*|| !localStorage.inicioDateGestion*/) {
      localStorage.setItem(
        'inicioGestion',
        Math.round(new Date().getTime() / 1000)
      )
      //localStorage.setItem('inicioDateGestion', new Date());
      store.commit('gestion/SET_INFO_CONTACTO', null)
      store.commit('vicidial/SET_CALL_IN_PROGRESS', true)
    }
  } else {
    localStorage.removeItem('inicioGestion')
    //localStorage.removeItem('inicioDateGestion');
    store.commit('vicidial/SET_CALL_IN_PROGRESS', false)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.user.isAuthenticated) {
      next()
      return
    }
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

router.mode = 'html5'

export default router
